import script from "./product-details.vue?vue&type=script&setup=true&lang=js"
export * from "./product-details.vue?vue&type=script&setup=true&lang=js"

import "./product-details.vue?vue&type=style&index=0&id=f5db98f2&scoped=true&lang=css"
import "./product-details.vue?vue&type=style&index=1&id=f5db98f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5db98f2"]])

export default __exports__